import styled from 'styled-components';

export const Container = styled.div`
  background: #ffffff;
  color: #666360;
  border: 1px solid #b1b4c4;
  height: 48px;
  border-radius: 10px;
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;

  .react-datepicker__input-container {
    height: 36px;

    display: flex;
    align-items: center;
    justify-content: center;

    input {
      color: var(--text);
      flex: 1;
      background: transparent;
      border: 0;
      width: 100%;

      &::placeholder {
        color: var(--gray-line);
      }
    }
  }

  .react-datepicker__header {
    background: var(--purple);
  }

  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: var(--white);
  }

  label {
    padding-bottom: 15px;
    color: var(--title-higlight);
  }
`;

export const Label = styled.label`
  display: flex;
  margin-bottom: 5px;
  font-size: 18px;
  color: var(--title-highlight);
`;

export const Error = styled.label`
  font-family: 'Inter', sans-serif;
  height: 20px;
  font-size: 15px;
  margin-bottom: 3px;
  color: var(--red);
  display: flex;
`;
